/*
  ネストしたプレーンオブジェクトを Rails の bracket 記法で FormData に展開する。
  ファイル添付があり multipart 送信が必要なときに、JSON 送信時と同じ payload を送るために使う。

  arg: ('customer_contract', { name: 'x', answer_item_forms: [{ question_item_id: 'a', by_customer: true }] })
  append:
    customer_contract[name]                                = 'x'
    customer_contract[answer_item_forms][][question_item_id] = 'a'
    customer_contract[answer_item_forms][][by_customer]      = 'true'

  規約:
    - 配列            -> key[] を要素ごとに繰り返す（要素がオブジェクトなら key[][child]）
    - オブジェクト      -> key[child] に再帰
    - boolean / number -> 文字列化（'true' / 'false' / '0' など）
    - File / Blob      -> そのまま append
    - null / undefined -> append しない（キーごとスキップ）
    - '' (空文字)      -> '' を送る（JSON 送信時の挙動に合わせる）
*/

const appendValue = (formData: FormData, key: string, value: unknown): void => {
  if (value === null || value === undefined) return

  if (value instanceof File || value instanceof Blob) {
    formData.append(key, value)
    return
  }

  if (Array.isArray(value)) {
    value.forEach((item) => appendValue(formData, `${key}[]`, item))
    return
  }

  if (typeof value === 'object') {
    Object.entries(value as Record<string, unknown>).forEach(([childKey, childValue]) =>
      appendValue(formData, `${key}[${childKey}]`, childValue),
    )
    return
  }

  formData.append(key, typeof value === 'string' ? value : String(value))
}

export const objectToFormData = (rootKey: string, value: unknown, formData = new FormData()): FormData => {
  appendValue(formData, rootKey, value)
  return formData
}
